import { Link } from 'react-router';

import { SidebarMenuSubButton, SidebarMenuSubItem } from '@/components/ui/sidebar';
import { type IAppsQuery } from 'src/graphql/actions/apps/apps.query';
import { AppAvatar } from 'src/widgets/AppCard';

import UnreadTasksIndicator from './UnreadTasksIndicator';

type Props = {
  app: IAppsQuery['apps']['nodes'][number];
  isActive: boolean;
  onNavigate?: () => void;
};

const SidebarAppRow = ({ app, isActive, onNavigate }: Props) => (
  <SidebarMenuSubItem>
    <SidebarMenuSubButton asChild isActive={isActive} className="h-8 translate-x-0 px-2.5">
      <Link to={`/applications/${app.id}`} onClick={onNavigate}>
        <AppAvatar
          appId={app.id}
          name={app.name ?? null}
          claimed={!app.unclaimed}
          shape={app.owned ? 'circle' : 'rounded-square'}
          logoUrl={app.logoUrl ?? undefined}
          size="xs"
        />
        {app.unclaimed ? (
          <span className="truncate font-medium text-muted-foreground">Untitled application</span>
        ) : (
          <span className="truncate font-medium text-foreground">{app.name}</span>
        )}
        <UnreadTasksIndicator taskCounts={app.taskCounts} />
      </Link>
    </SidebarMenuSubButton>
  </SidebarMenuSubItem>
);

export default SidebarAppRow;
